import { UpdateLicenseTOSDetectiveWhiteListDateRequest } from './../../models/ss-api/requests/update.license.tos.detective.white.list.date';
import { TOSDetectiveReport } from './../../models/domain/tos.detective.report';
import { Member } from './../../models/domain/member';
import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { TOSIPArray, TOSIP } from '../../models/domain/tos.ip';
import { ActivityLogsBaseRequest } from '../../models/ss-api/requests/activity.logs.base.request';
import { TOSActivityLogResponseArray } from '../../models/ss-api/responses/tos.activity.log.response';
import { LicenseManager } from '../../managers/License.manager';
import { MemberBasicsItemArray } from '../../models/domain/member.basics.item';
import { sortDirection } from '../../models/ss-api/responses/member.dashboard.license.response';
import { SortBot } from '../../../app/helpers/sort';
import { TOSDetectiveRequest } from '../../models/ss-api/requests/tos.detective.request';
import { TOSDetectiveReportArray } from '../../models/domain/tos.detective.report';
import { DialogService } from '../../services/modal-dialogs';
import { EmailDialog } from '../../dialogs/email/email.dialog';
import { EmailWindowType } from '../../models/domain/email.window.request';
import { TemplateTypes } from '../../models/domain/email.template.item';
import { SweetAlertService } from 'ng2-cli-sweetalert2';

@Component({
    selector: 'tos-report',
    templateUrl: './tos.report.component.html',
    styleUrls: ['./tos.report.component.scss']
})
export class TOSReportComponent implements OnInit {

    // VARIABLES
    IsBusy = false;
    AuditIsBusy = false;
    TOSMembersIsBusy = false;

    Whitelist: TOSIPArray = new TOSIPArray();
    Blacklist: TOSIPArray = new TOSIPArray();

    // Audit Logs
    AuditLogs: TOSActivityLogResponseArray;
    AuditLogStartDate: Date = new Date;
    AuditLogEndDate: Date = new Date;

    // TOS Detective
    DetectiveLogs: TOSDetectiveReportArray;
    DetectiveStartDate: Date = new Date(new Date().setDate(new Date().getDate() - 30));
    DetectiveEndDate: Date = new Date();
    DetectiveComputerThreshold: number = 2;
    DetectivePeriodInstanceThreshold: number = 3;

    HideCancelledOffendors: boolean = false;
    ShowingOldOffendors: Boolean = false;

    ShowWhitelist: boolean = false;

    WhitelistDays: number = 30;

    // TOS Members
    TOSMembers: MemberBasicsItemArray;

    // OTHER STUFF
    private licenseManager: LicenseManager = new LicenseManager();

    // Result Filters
    SearchTermIP = '';
    SearchTermMAC = '';
    SearchTermPC = '';

    AuditLogFilter: string;
    DetectiveFilter: string;

    constructor(private api: ssApiService, private gb: GlobalService, private dialogService: DialogService, private sweetAlert: SweetAlertService) { }

    sortByDate() { this.AuditLogs = SortBot.SortAuto(this.AuditLogs, 'AuditLog', 'DateTimeCreated'); }
    sortByMemberName() { this.AuditLogs = SortBot.SortAuto(this.AuditLogs, 'AuditLog', 'MemberName'); }
    sortByLicenseKey() { this.AuditLogs = SortBot.SortAuto(this.AuditLogs, 'AuditLog', 'LicenseKey'); }
    sortByIPAddress() { this.AuditLogs = SortBot.SortAuto(this.AuditLogs, 'AuditLog', 'IP'); }
    sortByMacAddress() { this.AuditLogs = SortBot.SortAuto(this.AuditLogs, 'AuditLog', 'MacAddress'); }
    sortByPCName() { this.AuditLogs = SortBot.SortAuto(this.AuditLogs, 'AuditLog', 'Username'); }

    sortOffendorsBy( sortVar1, sortVar2? ) {
        this.DetectiveLogs = SortBot.SortAuto( this.DetectiveLogs, sortVar1, sortVar2);
    }

    ngOnInit() {
        this.gb.SetPageTitle('TOS Report');
        this.AuditLogStartDate.setTime(this.AuditLogStartDate.getTime() - (24 * 60 * 60 * 1000) * 30); // subtract 30 days
        this.GetAuditLogs();
        this.GetTOSMembers();
        this.GetFlaggedIPs();
        this.GetWhitelistIPs();
        this.GetTOSDetectiveReport();
    }

    example() {

        // this.api.GetTOSMemberFlaggedIPs( MemberID );
        // this.api.GetTOSFlaggedComputers( MemberID );
        // this.api.GetTOSFlaggedMacAddresses( MemberID );
        // this.api.GetTOSMemberWhitelistedIPs( MemberID );
        this.api.GetTOSFlaggedIPs();
        this.api.GetTOSWhitelistedIPs();

    }

    GetAuditLogs() {
        let request = new ActivityLogsBaseRequest;
        request.StartDate = this.AuditLogStartDate;
        request.EndDate = this.AuditLogEndDate;

        this.AuditIsBusy = true;

        let disposable = this.api.GetTOSActivityLogs(request).subscribe(response => {
            disposable.unsubscribe();
            this.AuditLogs = response.Data;
            // this.AuditLogs = TOSActivityLogResponseArray.sortByDate( response.Data, sortDirection.Descending );
            this.AuditIsBusy = false;
            this.SortAuditByDate();
        }, error => {
            disposable.unsubscribe();
            this.AuditIsBusy = false;
        });
    }

    SortAuditByDate() {
        this.AuditLogs = TOSActivityLogResponseArray.sortByDate(this.AuditLogs, sortDirection.Descending);
    }

    GetTOSMembers(showOld: boolean = false) {
        this.TOSMembersIsBusy = true;
        let disposable = this.api.GetTOSMembers().subscribe(response => {
            disposable.unsubscribe();
            this.TOSMembers = response.Data.filter(item => {
                if (showOld) {
                    this.ShowingOldOffendors = true;
                    this.HideCancelledOffendors = false;
                    return true;
                } else if (this.HideCancelledOffendors) {
                    return (item.MemberType !== 110 && item.MemberType !== 210);
                } else {
                    return new Date(item.TOSDateTime) > new Date(new Date().setDate(new Date().getDate() - 90));
                }
            }).sort((left, right) => {
                if (left.TOSDateTime < right.TOSDateTime) {
                    return 1;
                } else {
                    return -1;
                }
            });
            this.TOSMembersIsBusy = false;
        }, error => {
            this.TOSMembersIsBusy = false;
        });
    }

    ToggleShowWhitelist() {
        this.ShowWhitelist = !this.ShowWhitelist;
    }

    GetFlaggedIPs() {

        let disposable = this.api.GetTOSFlaggedIPs().subscribe(response => {
            disposable.unsubscribe();
            this.Blacklist = response.Data;
            this.makeFakeTOS(this.Blacklist);
        }, error => {
            disposable.unsubscribe();
        });

    }

    GetWhitelistIPs() {

        let disposable = this.api.GetTOSWhitelistedIPs().subscribe(response => {
            disposable.unsubscribe();
            this.Whitelist = response.Data;
            this.makeFakeTOS(this.Whitelist);
        }, error => {
            disposable.unsubscribe();
        });


    }

    GetTOSDetectiveReport() {
        this.IsBusy = true;
        let request: TOSDetectiveRequest = {
            StartDate: this.DetectiveStartDate,
            EndDate: this.DetectiveEndDate,
            ComputerThreshold: this.DetectiveComputerThreshold,
            PeriodInstanceThreshold: this.DetectivePeriodInstanceThreshold,
            WhiteListOnly: this.ShowWhitelist
        };

        let disposable = this.api.GetTOSTOSDetective(request).subscribe(response => {
            this.IsBusy = false;
            if (response) {
                this.DetectiveLogs = response.Data;
            } else {

            }
            disposable.unsubscribe();
        });

    }

    NameForMemberType(type: number): string {
        return Member.GetMemberPersonType(type);
    }

    makeFakeTOS(myArray: TOSIPArray) {
        for (let i = 1; i < 5; i++) {
            let newTOS = new TOSIP;
            newTOS.AdminID = i * 3;
            newTOS.DateTimeCreated = new Date();
            newTOS.ID = i;
            newTOS.IP = '0.0.0.0' + i;
            myArray.push(newTOS);
        }
    }

    ToggleCancelledOffendors() {
        this.HideCancelledOffendors = !this.HideCancelledOffendors;
        this.GetTOSMembers();
    }

    onLicenseClick(LicenseKey: string) {
        this.IsBusy = true;
        let manager = new LicenseManager();
        manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
        manager.Load(LicenseKey, true);
        manager.OnChangesSaveResponse.subscribe(response => {
            this.GetAuditLogs();
            this.GetTOSMembers();
            this.GetFlaggedIPs();
            this.GetWhitelistIPs();
        });
    }

    SendEmail(item) {
        this.IsBusy = true;
        let memberDisposable = this.api.getMemberDashboard(item.Member_ID).subscribe(response => {
            this.IsBusy = false;
            memberDisposable.unsubscribe();
            let disposable = this.dialogService.addDialog(EmailDialog, {
                Type: EmailWindowType.Member,
                Templates: [TemplateTypes.CustomerService],
                MemberData: response.Data,
                TemplateID: 205
            }, { width: 1140, height: 800 }).subscribe(response => {
                disposable.unsubscribe();
            });
        });
    }

    WhitelistLicense(item: TOSDetectiveReport) {
        this.sweetAlert.swal({
            title: 'Whitelist License',
            text: 'Type in the desired number of days to be whitelisted',
            input: 'text',
            inputValue: this.WhitelistDays,
            showCancelButton: true
        }).then(response => {
            let whitelistEndDate = new Date(new Date().setDate(new Date().getDate() + response));
            let request: UpdateLicenseTOSDetectiveWhiteListDateRequest = {
                LicenseID: item.License_ID,
                NewTOSDectiveWhiteListDate: whitelistEndDate
            };
            let disposable = this.api.UpdateLicenseTOSDetectiveWhiteListDate(request).subscribe(response => {
                disposable.unsubscribe();
                if (response.Result) {
                    this.sweetAlert.swal({
                        type: 'success',
                        title: 'License Whitelisted',
                        timer: 1500
                    }).then( () => {
                        this.GetTOSDetectiveReport();
                    }, () => {
                        this.GetTOSDetectiveReport();
                    } );
                }
            });
        }, () => {});
    }

    RemoveFromWhitelist(item: TOSDetectiveReport) {
        this.sweetAlert.swal({
            title: 'Are you sure?',
            type: 'warning',
            showCancelButton: true
        }).then(response => {
            if (response) {
                let request: UpdateLicenseTOSDetectiveWhiteListDateRequest = {
                    LicenseID: item.License_ID,
                    NewTOSDectiveWhiteListDate: null
                };
                let disposable = this.api.UpdateLicenseTOSDetectiveWhiteListDate(request).subscribe(response => {
                    disposable.unsubscribe();
                    if (response.Result) {
                        this.sweetAlert.swal({
                            type: 'success',
                            title: 'License Removed From Whitelist',
                            timer: 1500
                        }).then( () => {
                            this.GetTOSDetectiveReport();
                        }, () => {
                            this.GetTOSDetectiveReport();
                        } );
                    }
                });
            }
        }, () => {});
    }

    ValidateMinimumDetectiveValue(event) {
        if (this.DetectiveComputerThreshold < 2) {
            this.DetectiveComputerThreshold = 2;
        }

        if (this.DetectivePeriodInstanceThreshold < 2) {
            this.DetectivePeriodInstanceThreshold = 2;
        }
    }


}
